import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import type { ModalProps } from 'antd';
import { Modal } from 'antd';
import styled from 'styled-components';

const StyledModal = styled((props: ModalProps) => <Modal {...props} />)`
    ${FONT_FAMILY.poppins};
    &&& {
        .ant-modal-title {
            margin: 0;
            padding: 0;
            color: ${TC.heading};
            ${DESKTOP_SIZES[SIZES.HEADING_SM].fontSize}
            ${DESKTOP_SIZES[SIZES.HEADING_SM].lineHeight}
            ${DESKTOP_SIZES[SIZES.HEADING_SM].fontWeight}
        }

        .ant-modal-body {
            padding: 0;
            ${DESKTOP_SIZES[SIZES.HEADING_XXXS].fontSize}
            ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight}
            color: ${TC.heading};
        }

        .ant-modal-close {
            ${DESKTOP_SIZES[SIZES.BODY_LG].fontSize}
            color: ${TC.heading};
            margin-right: 12px;
            top: 25px;
        }

        .ant-modal-close-icon {
            ${DESKTOP_SIZES[SIZES.BODY_LG].fontSize}
            color: ${TC.heading};
        }

        .ant-modal-footer {
            display: flex;
            justify-content: space-between;
            gap: 16px;
            width: 100%;
            padding: 32px 16px 16px;
        }
    }
`;

export default StyledModal;
